import { types } from './types';

const initialState = {
    list: {
        data: [],
        pagination: {
            totalPage: 0,
            currentPage: 1,
            totalSize: 0,
            pageSize: 0
        }
    },
    users: {
        data: [],
        pagination: {
            totalPage: 0,
            currentPage: 1,
            totalSize: 0,
            pageSize: 0
        }
    },
    statistics: {
        count_open_game: undefined,
        count_replenishment: undefined,
        count_transaction: undefined,
        count_withdrawals: undefined,
        dashboard: []
    },
    scrollers: {
        open_game_users: {
            list: [],
            page: 1,
            pageSize: 25,
            total: 1,
            totalSize: 1,
        },
        deposits_users: {
            list: [],
            page: 1,
            pageSize: 25,
            total: 1,
            totalSize: 1,
        },
        deposits_users_by_currency: {
            list: [],
            page: 1,
            pageSize: 25,
            total: 1,
            totalSize: 1,
        },
        transactions_users: {
            list: [],
            page: 1,
            pageSize: 25,
            total: 1,
            totalSize: 1,
        },
        withdrawals_users: {
            list: [],
            page: 1,
            pageSize: 25,
            total: 1,
            totalSize: 1,
        },
        withdrawals_users_by_currency: {
            list: [],
            page: 1,
            pageSize: 25,
            total: 1,
            totalSize: 1,
        },
        open_game_by_user: {},
        deposits_by_user: {},
        transactions_by_user: {},
        withdrawals_by_user: {},
    }
}

export function mailingReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_GET_MAILING:
            return { ...state, list: action.payload };
        
        case types.SET_GET_MAILING_USERS:
            return { ...state, users: action.payload };
        
        case types.SET_GET_MAILING_STATISTICS_COUNT_OPEN_GAME: 
            return {
                ...state,
                statistics: {
                    ...state.statistics,
                    count_open_game: action.payload,
                }
            }
        case types.SET_GET_MAILING_STATISTICS_COUNT_REPLENISHMENT: 
            return {
                ...state,
                statistics: {
                    ...state.statistics,
                    count_replenishment: action.payload,
                }
            }
        case types.SET_GET_MAILING_STATISTICS_COUNT_TRANSACTION:
            return {
                ...state,
                statistics: {
                    ...state.statistics,
                    count_transaction: action.payload,
                }
            }

        case types.SET_GET_MAILING_STATISTICS_COUNT_WITHDRAWALS:
            return {
                ...state,
                statistics: {
                    ...state.statistics,
                    count_withdrawals: action.payload,
                }
            }
        case types.SET_GET_MAILING_STATISTICS_DASHBOARD:
            return {
                ...state,
                statistics: {
                    ...state.statistics,
                    dashboard: action.payload,
                }
            }
        case types.SET_GET_MAILING_STATISTICS_SCROLLER_USERS_OPEN_GAME: 
            return {
                ...state,
                scrollers: {
                    ...state.scrollers,
                    open_game_users: action.payload,
                }
            }
        
        case types.SET_GET_MAILING_STATISTICS_SCROLLER_OPEN_GAME_BY_USER:
            return {
                ...state,
                scrollers: {
                    ...state.scrollers,
                    open_game_by_user: action.payload,
                }
            }

        case types.SET_GET_MAILING_STATISTICS_SCROLLER_USERS_DEPOSITS:
            return {
                ...state,
                scrollers: {
                    ...state.scrollers,
                    deposits_users: action.payload
                }
            }
        case types.SET_GET_MAILING_STATISTICS_SCROLLER_USERS_DEPOSITS_BY_USER:
            return {
                ...state,
                scrollers: {
                    ...state.scrollers,
                    deposits_by_user: action.payload
                }
            }

        case types.SET_GET_MAILING_STATISTICS_SCROLLER_USERS_TRANSACTIONS:
            return {
                ...state,
                scrollers: {
                    ...state.scrollers,
                    transactions_users: action.payload
                }
            }
        case types.SET_GET_MAILING_STATISTICS_SCROLLER_USERS_TRANSACTIONS_BY_USER:
            return {
                ...state,
                scrollers: {
                    ...state.scrollers,
                    transactions_by_user: action.payload
                }
            }
        
        case types.SET_GET_MAILING_STATISTICS_SCROLLER_USERS_WITHDRAWALS:
            return {
                ...state,
                scrollers: {
                    ...state.scrollers,
                    withdrawals_users: action.payload
                }
            }
        case types.SET_GET_MAILING_STATISTICS_SCROLLER_USERS_WITHDRAWALS_BY_USER:
            return {
                ...state,
                scrollers: {
                    ...state.scrollers,
                    withdrawals_by_user: action.payload
                }
            }

        case types.SET_GET_MAILING_STATISTICS_SCROLLER_USERS_DEPOSITS_BY_CURRENCY:
            return {
                ...state,
                scrollers: {
                    ...state.scrollers,
                    deposits_users_by_currency: action.payload
                }
            }

        case types.SET_GET_MAILING_STATISTICS_SCROLLER_USERS_WITHDRAWALS_BY_CURRENCY:
            return {
                ...state,
                scrollers: {
                    ...state.scrollers,
                    withdrawals_users_by_currency: action.payload
                }
            }

        default:
            return state
    }
}